<template>
<div class="content">
  <nav>
    <router-link to="/qrcode">网址二维码生成器</router-link>
    <router-link class="active" to="/shortlink">短链接生成器</router-link>
  </nav>
  <h1>短链接生成器</h1>
  <div class="form">
    <input v-model.trim="longUrl" placeholder="http://" autofocus><button @click="generatorShortlink">生成短链接</button>
  </div>
  <div class="output">
    <input id="shortlink" :value="shortUrl" disabled>
    <button v-if="shortUrl" @click="copyToClip">复制短链接</button>
  </div>
</div>
</template>

<script>
// import ajaks from 'ajaks';
import axios from 'axios'

export default {
  name: "shortlink",
  data() {
    return {
      longUrl: '',
      shortUrl: '',
    }
  },
  methods: {
    generatorShortlink: function () {
      let longUrl = this.longUrl;
      // ajaks.post('/url/shorten', {longUrl}).then(data => {
      //   this.shortUrl = data.code && data.code === 400 ? data.message : data.shortUrl;
      // });
      const params = new URLSearchParams()
      params.append('longUrl', longUrl)
      axios.post('/toolbox/link/api/url/shorten', params).then(({ data }) => {
        this.shortUrl = data.code && data.code === 400 ? data.message : data.shortUrl;
      });
    },
      copyTextToClipboard: function(text) {
          var textArea = document.createElement("textarea");

          textArea.style.position = 'fixed';
          textArea.style.top = 0;
          textArea.style.left = 0;
          textArea.style.width = '2em';
          textArea.style.height = '2em';
          textArea.style.padding = 0;
          textArea.style.border = 'none';
          textArea.style.outline = 'none';
          textArea.style.boxShadow = 'none';
          textArea.style.background = 'transparent';
          textArea.value = text;

          document.body.appendChild(textArea);

          textArea.select();

          try {
              var msg = document.execCommand('copy') ? '成功' : '失败';
              console.log('复制内容 ' + msg);
          } catch (err) {
              console.log('不能使用这种方法复制内容');
          }

          document.body.removeChild(textArea);
      },
    copyToClip: function () {
      // Select the uri link anchor text
      var block = document.querySelector('#shortlink');
      this.copyTextToClipboard(block.value)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/tool.scss';
</style>
